import { render, staticRenderFns } from "./archive-goal-modal.vue?vue&type=template&id=f7c98ab6&"
import script from "./archive-goal-modal.vue?vue&type=script&lang=ts&"
export * from "./archive-goal-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports